<template>
  <div class="transfer-notes-table table-component">

    <artisio-table :pagination="tableData.pagination" :sort="tableData.ordering" :items="tableData.rows"
                   :busy="tableData.loading" :fields="tableFields" :checkboxes="true" :search="tableData.search"
                   :enable-simple-search="false" enable-frontend-export
                   export-permission-name="export_transfernote" export-vuex-module-name="transferNotes"
                   @paramsChanged="getTableData" selectable filter-toggle-string="transfer-note-table"
                   show-toggle-columns :extra-data="extraData" @update-toggle-columns="updateToggleColumns"
                   @on-column-save="updateToggleColumns" requires-min-height>

      <template v-slot:search-form-placeholder>
        <search-collapse table-id="transfer-note-table">
          <transfer-note-search/>
        </search-collapse>
      </template>


      <template slot="cell(type)" slot-scope="{item}">
        {{ item.type | removeUnderscores | toUpperCaseEveryWord }}
      </template>
      <template slot="cell(status)" slot-scope="{item}">
        {{ item.status | removeUnderscores | toUpperCaseEveryWord }}
      </template>
      <template slot="cell(service_provider)" slot-scope="{item}">
        {{ item.service_provider | truncate(50) }}
      </template>
      <template slot="cell(title)" slot-scope="{item}">
        {{ item.title | truncate(50) }}
      </template>
      <template slot="cell(issue_date)" slot-scope="{item}">
        {{ item.issue_date | toDateTime }}
      </template>
      <template slot="cell(arrival_date)" slot-scope="{item}">
        {{ item.arrival_date | toDateTime }}
      </template>
      <template slot="cell(created_at)" slot-scope="{item}">
        {{ item.created_at | toDate }} by {{ item.created_by.display_name }}
      </template>
      <template slot="cell(updated_at)" slot-scope="{item}">
        {{ item.updated_at | toDate }} by {{ item.updated_by.display_name }}
      </template>
      <template slot="cell(origin_item_location)" slot-scope="{item}">
        <span v-if="item.origin_item_location">
          {{ item.origin_item_location.name }}
        </span>
      </template>
      <template slot="cell(destination_item_location)" slot-scope="{item}">
        <span v-if="item.destination_item_location">
          {{ item.destination_item_location.name }}
        </span>
      </template>
      <template slot="cell(rep_user)" slot-scope="{item}">
        <span v-if="item.rep_user">
          {{ item.rep_user.display_name }}
        </span>
      </template>
      <template slot="cell(actions)" slot-scope="{item}">
        <div class="position-relative">
          <b-dropdown right class="text-white" variant="primary" no-caret size="sm">
            <template #button-content>
              <font-awesome-icon icon="ellipsis-v" class="icon"/>
            </template>
            <b-dd-item @click="onPdfViewClick(item)" v-permission="'view_transfernote'">
              {{ $t('View PDF') }}
            </b-dd-item>

          </b-dropdown>
        </div>
      </template>
      <template slot="cell(contract_status)" slot-scope="{item}">
        <span v-if="item.contract_status" v-as-status="item.contract_status">
          {{ item.contract_status | removeUnderscores | toUpperCaseEveryWord }}
        </span>
        <span v-as-status="item.contract_status" v-else>{{ $t('N/A') }}</span>
      </template>
      <template slot="cell(no)" slot-scope="{item}">
        {{ item.transfer_note_no }}
        <action-buttons :delete-permission="'delete_transfernote'"
                        :edit-permission="'change_transfernote'"
                        @editClick="onEditClick(item)"
                        @deleteClick="onRemoveClick(item)"
                        :remove="item.status === 'draft'"
                        :view="false"/>
      </template>

    </artisio-table>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioTable from "../../core/components/ams-table/ArtisioTable";
  import {SOURCE_TRANSFER_NOTES_TABLE, TRANSFER_NOTES_TABLE_NAME} from "../constants";
  import SearchCollapse from "../../core/components/search-collapse/SearchCollapse";
  import cloneDeep from "lodash/cloneDeep";
  import TransferNoteSearch from "@/modules/transfer-notes/TransferNoteSearch";
  import ActionButtons from "@/core/components/ams-table/ActionButtons";

  const {mapState, mapActions} = createNamespacedHelpers('transferNotes');
  const {mapActions: mapActionsGlobal} = createNamespacedHelpers('global');

  export default {
    name: "TransferNoteTable",
    components: {ActionButtons, TransferNoteSearch, SearchCollapse, ArtisioTable},
    data() {
      return {}
    },
    computed: {
      ...mapState({
        tableData: state => state.tableData[state.tableSource],
        toggleColumns: state => state.tableData[state.tableSource].toggleColumns,
        tableSource: state => state.tableSource,
      }),
      tableFields() {
        return cloneDeep(this.toggleColumns.fields).filter(f => f.isVisible);
      },
      extraData() {
        return {
          ...this.toggleColumns,
          excludeColumns: [],
          tableName: `${TRANSFER_NOTES_TABLE_NAME}.${this.tableSource}`,
        }
      },
    },
    methods: {
      ...mapActions(['getTableData', 'showModal', 'removeTransferNote', 'getModalObject', 'updateToggleColumns']),
      ...mapActionsGlobal([
        'showGeneralContractModal',
        'getGeneralContractModalData',
      ]),
      onEditClick(item) {
        this.showModal({source: SOURCE_TRANSFER_NOTES_TABLE})
        this.getModalObject({uuid: item.uuid, source: SOURCE_TRANSFER_NOTES_TABLE});
      },
      async onRemoveClick(item) {
        this.$confirm(
          this.$i18n.t("Are you sure you want to delete following transfer note?"),
          this.$i18n.t('Transfer note was successfully deleted'),
          this.removeTransferNote,
          item
        );
      },
      onPdfViewClick(item) {
        this.getGeneralContractModalData({
          object: item,
          fileType: 'transfer_note_contract',
          objectName: 'transfernote',
        });
        this.showGeneralContractModal({
          source: SOURCE_TRANSFER_NOTES_TABLE,
          object: item,
          fileType: 'transfer_note_contract',
          objectName: 'transfernote',
          enableESignature: false,
          refreshOnSubmit: true,
          modalTitle: this.$i18n.t("Transfer Note")
        })
      }
    },
    mounted() {
      this.getTableData();
    }
  }
</script>

<style lang="scss" scoped>
  @import "./scss/variables";

  .artisio-table {
    /deep/ {
    }
  }
</style>

